// =============================================================================
// CLIENT CONFIG — change these per-deployment to white-label the booking system.
// All visual tokens are now driven from this one file. Drop in a new client's
// brand and the entire site (header, hero, services, rescue band, footer)
// retheme on next refresh.
// =============================================================================

export const businessConfig = {
  name: "Pup's Parlour",
  tagline: "Boutique grooming & boarding for the pets of Moose Jaw",
  phone: "306-691-0001",
  email: "hello@pupsparlour.example",
  address: "290 9th Ave NW, Moose Jaw, SK",
  // Logo: lucide-react icon (default) OR a hosted image URL.
  // To swap to a hosted logo, set: logoImage: "https://your-cdn/logo.png"
  logoIcon: "PawPrint",
  logoImage:
    "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/m3uunf7g_317804127_593266746136028_4825281955976803365_n%20%281%29.jpg",
  // Optional Google Apps Script Web App URL — left as a placeholder.
  // When deploying with the Apps Script backend, point the frontend to this URL.
  appsScriptUrl: "PASTE_YOUR_APPS_SCRIPT_WEBAPP_URL_HERE",
  // Six base colours drive the whole site. Soft / hover / deep variants are
  // computed automatically (see /app/frontend/src/lib/theme.js).
  // Set any value to `null` to keep the corresponding CSS default.
  colors: {
    ink:     "#2A2540", // body text + dark footer
    cream:   "#FBF3F0", // alternating section background
    indigo:  "#4D54AB", // primary brand
    gold:    "#D4A24C", // accent / CTA fill
    rescue:  "#7E5C8B", // rescue band background
    surface: "#F0E5DD", // card border / hover state
    // Optional explicit overrides (otherwise auto-darkened from base colours):
    // goldHover:  "#c29342",
    // rescueDeep: "#6a4d76",
    // creamSoft:  "#F5EBE6",
  },
  // ---------------------------------------------------------------------
  // MEDIA — every image placeholder in the site lives here. Set any value
  // to `null` to fall back to the dashed-border placeholder. All files are
  // square/landscape JPG/PNG hosted on a CDN of your choice.
  // ---------------------------------------------------------------------
media: {
  heroBackground: null,
  heroVideoDesktop: "/assets/hero-video-desktop.mp4",
  heroVideoMobile: "/assets/hero-video-mobile.mp4",
  heroPoster: null,
  polaroid1: "/assets/polaroid-1.mp4",
  polaroid2: "/assets/polaroid-2.mp4",
  polaroid3: "/assets/polaroid-3.mp4",
  polaroid4: "/assets/polaroid-4.mp4",
  polaroid5: "/assets/polaroid-5.mp4",
  polaroid6: "/assets/polaroid-6.mp4",
    // Why-families polaroids (square, ≥ 600×600).
    polaroidGroomer:
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=700&q=80",
    polaroidHappyDog:
      "https://images.unsplash.com/photo-1543466835-00a7907e9de1?auto=format&fit=crop&w=700&q=80",
    // Rescue partner section — rescue dog photo.
    rescueDogPhoto:
      "https://images.unsplash.com/photo-1561037404-61cd46aa615b?auto=format&fit=crop&w=900&q=80",
  },
  // ---------------------------------------------------------------------
  // SERVICE IMAGES — one per service id (matches the `id` field used in
  // /app/frontend/src/components/landing/ServicesSection.jsx).
  // ---------------------------------------------------------------------
  serviceImages: {
    "dog-grooming":
      "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/o2qdi1al_dog%20grooming.png",
    "cat-grooming":
      "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/v58o28dg_cat%20grooming.png",
    "daycare":
      "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/sos1rra5_day%20care.png",
    "boarding":
      "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/zpgzildw_boarding.png",
    "boutique":
      "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/vsbzoz1h_Boutique.png",
  },
};

export const wizardSteps = [
  { id: 1, label: "Services" },
  { id: 2, label: "Date & Time" },
  { id: 3, label: "Your Details" },
  { id: 4, label: "Confirm" },
];

/* ---------------------------------------------------------------------------
 * Examples for forks (just paste over the `colors` object above):
 *
 *  Whiskey & Pearls Hair Salon:
 *    colors: { ink: "#1F1A18", cream: "#F8F1EA", indigo: "#5B1F2B",
 *              gold: "#9F8054", rescue: "#3C2B26", surface: "#EAD9C7" }
 *
 *  Sahara Spa:
 *    colors: { ink: "#2C2A22", cream: "#F4EFE3", indigo: "#5C7A5A",
 *              gold: "#C7965A", rescue: "#7B5E3F", surface: "#E2D7BE" }
 *
 *  Nit's Thai Food:
 *    colors: { ink: "#1B1B1B", cream: "#FBF6EC", indigo: "#4D2A1F",
 *              gold: "#D5A03A", rescue: "#7C2A1A", surface: "#EBDCB8" }
 * ------------------------------------------------------------------------- */
